/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Input, Label, Button, CustomLoading, Breadcrumb, SaveIcon, CustonModal } from "../../../../Components";

/* 🔗 SERVICE */
import { EquipamentTypesServices } from "../../../../Services/equipamentosServices/types";

/* 📁 ASSETS*/
import { Excluir } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContainerRow, ContainerColumn, ImageIcon, ButtonsContainer, RowContainer } from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const EquipmentTypeView = () => {

    const { t } = useTranslation();

    document.title = t("administrative.sub-items.equipments-types.view.document-title");

    const navigationFlow =  [
        { text: 'administrative', page: '/adm/equipamentos' },
        { text: 'equipments', page: '/adm/equipamentos' },
        { text: 'equipment-types', page: '/adm/tipos-equipamentos' },
        { text: 'equipment-type', page: null },
    ]
    
    const navigate = useNavigate();
    let { id } = useParams();

    const Services = useRef(new EquipamentTypesServices());

    const [loading, setLoading] = useState(true);
    const [activeModal, setActiveModal] = useState('');
    const [equipmentType, setEquipmentType] = useState(null);
    
    const NameField = useRef();
    const ModelField = useRef();
    const observationField = useRef();
    const timeOutComunicationField = useRef();

    const NameValue = useRef();
    const ModelValue = useRef();
    const observationValue = useRef();
    const timeOutComunicationValue = useRef();

    useEffect(() => {       
        // Busca dados do grupo
        const getCurrent = async () => {
            setLoading(true);
            try {
                let currentItem = await Services.current.getEquipmentType(id);

                if (!currentItem) return;
                if (NameField.current && typeof NameField.current.getInputDOMNode === "function") {
                    NameField.current.getInputDOMNode().value = currentItem.name;
                    NameValue.current = currentItem.name;
                }
                setEquipmentType(currentItem);                
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        getCurrent();
    }, [id]);

    // method-spoofing
    // Salva as edições do usuário
    const Save = async() => {
        if(isValidField(NameValue.current)){
            let form = {};
                            
            if(NameValue.current){form = {...form, 'name': NameValue.current}}
            if(timeOutComunicationValue.current){form = {...form, 'communication_timeout_minutes': timeOutComunicationValue.current}}
            if(ModelValue.current){form = {...form, 'equipable_type': ModelValue.current}}
            if(observationValue.current){form = {...form, 'observation': observationValue.current}}
            form = {...form, '_method': 'PATCH'}
            
            Services.current.editEquipmentType(equipmentType.id , form);
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return (
        <>
            <Container>
                <Breadcrumb flow={navigationFlow}/>
                <TitleContainer>
                    <Title>{equipmentType?.name}</Title>
                </TitleContainer>

                {loading ? <CustomLoading width={'150px'} height={'150px'}/>:
                    <>
                        <ContainerRow onSubmit={(e) => e.preventDefault()}>
                            <ContainerColumn>
                                <Label text={t("inputs.name.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='name' 
                                    name='name' 
                                    type="text" 
                                    placeholder={t("inputs.name.placeholder")}
                                    innerRef={NameField}
                                    value={equipmentType?.name}
                                    invalidMessage={t("inputs.name.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => {
                                        NameValue.current = text
                                        setEquipmentType({...equipmentType, 'name': text})
                                    }}> 
                                </Input>

                                <Label text={t("inputs.observations.label")} aling="flex-start"/>
                                <Input
                                    aling="flex-start"
                                    id='observation'
                                    name='observation'
                                    type="text"
                                    placeholder={t("inputs.observations.placeholder")}
                                    innerRef={observationField}
                                    value={equipmentType?.observation}
                                    invalidMessage={t("inputs.observations.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => {
                                        observationValue.current = text
                                        setEquipmentType({...equipmentType, 'observation': text})
                                    }}>
                                </Input>
                            </ContainerColumn>
                            <ContainerColumn>
                                <Label text={t("inputs.timeout-comunication.label")} aling="flex-start"/>
                                <Input
                                    aling="flex-start"
                                    id='timeoutComunication'
                                    name='timeoutComunication'
                                    type="number"
                                    placeholder={t("inputs.timeout-comunication.placeholder")}
                                    innerRef={timeOutComunicationField}
                                    value={equipmentType?.communication_timeout_minutes}
                                    invalidMessage={t("inputs.timeout-comunication.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => {
                                        setEquipmentType({...equipmentType, 'communication_timeout_minutes': text})
                                        timeOutComunicationValue.current = text
                                    }}>
                                </Input>
                            </ContainerColumn>

                            <ContainerColumn>
                                <Label text={t("inputs.model.label")} aling="flex-start"/>
                                <Input
                                    aling="flex-start"
                                    id='model'
                                    name='model'
                                    type="text"
                                    placeholder={t("inputs.model.placeholder")}
                                    innerRef={ModelField}
                                    value={equipmentType?.equipable_type}
                                    invalidMessage={t("inputs.model.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => {
                                        setEquipmentType({...equipmentType, 'equipable_type': text})
                                        ModelValue.current = text
                                    }}>
                                </Input>
                            </ContainerColumn>
                        </ContainerRow>



                        <ButtonsContainer>
                            <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={() => Save()}/>
                            <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} 
                                onClick={() => setActiveModal('delete-group')} 
                            icon={<ImageIcon src={Excluir}/>}/>
                        </ButtonsContainer>  
                    </>
                }
            </Container>

            <CustonModal Title={t("modal.delete-equipment-group.title")} Active={activeModal === 'delete-group'}>
                <RowContainer>
                    <Button width={'fit-content'} text={t("buttons.confirm")} onClick={() => Services.current.deleteEquipmentType(id, navigate)}/>
                    <Button $borderRadius={'10px'} text={t("buttons.cancel")} color={'white-red'} onClick={() => setActiveModal('')}> {t("buttons.cancel")} </Button>
                </RowContainer>
            </CustonModal>
        </>
    );
}

export default EquipmentTypeView;